import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import QuestionList from 'src/components/patients/questions/QuestionList';

const PatientQuestions = () => {
  return <><Typography fontSize={'20px'} fontWeight={500} color={'primary.dark'} mt={'18px'} mb={'16px'}>問診票</Typography>
  <Stack direction={"row"} spacing={'20px'} width={'auto'}>
    <QuestionList />
  </Stack></>;
};

export default PatientQuestions;
